module.exports = __webpack_public_path__ + "img/roundtable-1.3373c9fb.png";